import { EnvironmentConfig, ENVIRONMENTS } from 'env';
import { china_settings, global_settings } from './settings';

export const envSettings =
  EnvironmentConfig.env === ENVIRONMENTS.GLOBAL
    ? global_settings
    : china_settings;
